import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { WithPNOColleaguesRequest, WithPNOColleaguesResult } from '../../../features/linking-with-pno-colleagues/models/with-pno-colleagues-request.intraface'
import { ConfigService } from '../../services/config.service'
import { LogService } from '../../services/log.service'

@Injectable({ providedIn: 'root' })
export class WithPNOColleaguesService {
   private readonly _cn = this.constructor.name
   private readonly _httpClient = inject(HttpClient)
   private readonly _logService = inject(LogService)
   private readonly _configService = inject(ConfigService)

   getWithPNOColleaguesData(request: WithPNOColleaguesRequest): Observable<WithPNOColleaguesResult> {
      this._logService.info(this._cn, this.getWithPNOColleaguesData.name, this._logService.START)
      this._logService.debug(this._cn, this.getWithPNOColleaguesData.name, 'search fields:', request)
      let req = { ...request, filtering: { ...request.filtering, statuses: [1, 2, 9], partnerSearchUnexpired: true } }
      return this._httpClient.post<WithPNOColleaguesResult>(`${this._configService.new_BE_ApiUrl}` + `/solr/projects:search`, req)
   }
}
